import { render } from "./DDialog.vue?vue&type=template&id=b9975932&scoped=true"
import script from "./DDialog.vue?vue&type=script&lang=js"
export * from "./DDialog.vue?vue&type=script&lang=js"

import "./DDialog.vue?vue&type=style&index=0&id=b9975932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9975932"]])

export default __exports__